import { ViewLayout } from './ViewLayout';

export default ViewLayout;



// WEBPACK FOOTER //
// ./src/components/ViewLayout/index.js